import type { IViewPortController, IViewPortManipulationApi } from '@/engine/app/interfaces';

export class ViewPortContextIntegrationApi implements IViewPortManipulationApi {
  private _viewPortController?: IViewPortController;

  // IViewPortManipulationApi
  public setViewPortController(viewPortController: IViewPortController | undefined): void {
    this._viewPortController = viewPortController;
  }

  private _getViewPortController(): IViewPortController {
    if (!this._viewPortController) {
      throw new Error('ViewPortController should be defined');
    }
    return this._viewPortController;
  }

  public performContextCommand(commandName: number): void {
    this._getViewPortController().triggerEvent('contextCommand', commandName);
  }
}
